import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const TermsOfService = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>Terms of Service</h3>
                <p> Version 1.3 | Effective Date: 1st May 2025</p>
                <p>
                    Welcome to Curry King (Private) Limited ("Curry King", "we", "our", or "us"). These Terms of Service ("Terms") govern your use of our website, services, and the purchase of our products.
                </p>
                <p> By accessing our website or using our services, you agree to be bound by these Terms. If you do not agree, please do not use our services.</p>
                <hr />
                <h5 className='fw-bold'>1. Use of Our Services</h5>
                <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You must not use our services in any way that breaches any applicable law or regulation.</p>
                <hr />
                <h5 className='fw-bold'>2. Eligibility</h5>
                <p>You must be at least 18 years old to place an order with us. While our food services are intended for all age groups, all orders must be placed by adults.</p>
                <hr />
                <h5 className='fw-bold'>3. Orders and Payment</h5>
                <p>We use the information we collect to:</p>
                <ul>
                    <li>
                        By placing an order, you agree to provide current, complete, and accurate purchase and account information.
                    </li>
                    <li>
                        Prices are listed in Sri Lankan Rupees (LKR) and are inclusive of applicable taxes unless otherwise stated.
                    </li>
                    <li>Payment must be made through the available methods provided at checkout.
                    </li>
                    <li>
                        We reserve the right to refuse or cancel your order at any time for reasons including but not limited to product availability, errors in product information, or errors in your order.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>4. Delivery and Pickup</h5>
                <ul>
                    <li>
                        We deliver through our designated carts and selected partners.
                    </li>
                    <li>
                        Delivery times are estimates and not guaranteed.
                    </li>
                    <li>You are responsible for providing accurate delivery details.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>5. Product Descriptions and Availability</h5>
                <p>We strive to ensure that all product descriptions, images, and prices are accurate. However, we do not warrant that descriptions and other content are accurate, complete, reliable, or error-free. Availability of products is subject to change without notice.</p>
                <hr />
                <h5 className='fw-bold'>6. Intellectual Property Rights</h5>
                <p>All content on our website, including logos, text, graphics, images, and software, is the property of Curry King or its licensors and is protected by intellectual property laws. You may not use, reproduce, distribute, or create derivative works from our content without our prior written permission.</p>
                <hr />
                <h5 className='fw-bold'>7. User Conduct</h5>
                <p>You agree not to:</p>
                <ul>
                    <li>Use the website or services in any unlawful manner.</li>
                    <li>Interfere with or disrupt the operation of the website or servers.</li>
                    <li>Post or transmit any harmful, offensive, or illegal material.</li>
                </ul>
                <hr />
                <h5 className='fw-bold'>8. Limitation of Liability</h5>
                <p>To the maximum extent permitted by law, Curry King shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including loss of profits, data, or other intangibles arising out of your use of our services.</p>
                <hr />
                <h5 className='fw-bold'>9. Indemnification</h5>
                <p>You agree to indemnify and hold harmless Curry King, its directors, officers, employees, and agents from any claims, liabilities, damages, losses, and expenses arising out of your use of our services or your violation of these Terms.</p>
                <hr />
                <h5 className='fw-bold'>10. Changes to These Terms</h5>
                <p>We may revise these Terms from time to time. Any changes will be posted on our website, and the updated Terms will be effective immediately upon posting. Your continued use of our services constitutes your acceptance of the revised Terms.</p>
                <hr />
                <h5 className='fw-bold'>11. Governing Law</h5>
                <p>These Terms are governed by the laws of Sri Lanka. Any disputes arising out of or related to these Terms or our services shall be subject to the exclusive jurisdiction of the courts of Sri Lanka.</p>
                <hr />
                <h5 className='fw-bold'>12. Contact Us</h5>
                <p>For any questions regarding these Terms, please contact us at:</p>
                Curry King (Private) Limited
                <br />
                55/2 Vauxhall Lane,
                <br />
                Colombo 2, Sri Lanka
                <br />
                Email: regulatory@curryking.lk
                <hr />
                <p>Thank you for choosing Curry King.</p>
            </div>
        </>
    )
}

export default TermsOfService;